export const APP_URL = 'https://namealert.io';
export const CREDIT_REFRESH_INTERVAL = 1 * 60 * 1000; // minutes
export const PaymentPlan = {
  basic: 1000,
  premium: 2000,
};
export const API_ENDPOINT = {
  CHAT: 'https://us-central1-discvry.cloudfunctions.net/chatWithAssistantApi',
  signupUrl: 'https://us-central1-discvry.cloudfunctions.net/signupUser',
  loginUrl: 'https://loginuser-madox6irya-uc.a.run.app',
  loginWithTokenUrl: 'https://logingoogle-madox6irya-uc.a.run.app',
  resetPasswordUrl: 'https://us-central1-discvry.cloudfunctions.net/resetPassword',
  initialCreditsUrl: 'https://us-central1-discvry.cloudfunctions.net/addInitialCreditEntry',
  remainingCreditsUrl: 'https://us-central1-discvry.cloudfunctions.net/remainingCreditsV2',
  pricingPlanUrl: 'https://us-central1-discvry.cloudfunctions.net/getPricingPlans',
  promptUrl: 'https://us-central1-discvry.cloudfunctions.net/getPrompts',
}
